<script>
  import { onMount } from "svelte";
  import { mapStore } from "../../stores/map.store";
  import { hooksStore } from "../../stores/hooks.store";
  import { userStore } from "../../stores/user.store";
  import { configStore } from "../../stores/config.store";
  import { tempStore } from "../../stores/temp.store";
  import {
    vratVrstvyMapyPodlaTypu,
    vratHtmlKodFarbyPodlaTypu,
    vratTypPodlaKodu,
  } from "../../helpers/config";

  import { get as get_store } from "svelte/store";
  import get from "get-value";
  import SideManager from "./SideManager.svelte";
  import Popup from "./Popup.svelte";
  import Controls from "./Controls/Controls.svelte";

  let meranieAktivne = false;

  import {
    ulozAktualneZobrazenieMapy,
    ziskajUlozenuPoziciuMapy,
  } from "./maplibre.func";

  import { sourceExists } from "../../helpers/map";

  let container, map;
  /**
   * kedze nacitanie maplibre chvilku trva a nacitava sa az po mountnuti tohto komponentu
   * tak si nacitanu mapu ukladam do store aby som ju mohol pouzit aj neskor (ked sa nacita mapbox)
   */
  mapStore.initMap({
    getMap: () => map,
  });

  hooksStore.addAction("resizeMaplibre", "Maplibre", () => {
    map.resize();
  });

  hooksStore.addAction("aktualizujVrstvyNaMape", "Maplibre", () => {
    let vrstvy = get(get_store(userStore), "options.mapa.vrstvy", false);

    let vrstvyUrl = {
      vector: "",
      raster: "",
    };

    vrstvy.forEach((vrstva) => {
      if (vrstvyUrl[vrstva.typ] === undefined) {
        vrstvyUrl[vrstva.typ] = "";
      }

      vrstvyUrl[vrstva.typ] += vrstva.kodUrl;

      vrstvyUrl[vrstva.typ] += vrstva.type === "radio" ? "|" : ",";
    });

    for (const type in vrstvyUrl) {
      if (vrstvyUrl[type]) {
        vrstvyUrl[type] = vrstvyUrl[type].replace(/,\s*$/, "");
      }
    }

    for (const type in vrstvyUrl) {
      const id = `interne_vrstvy_${type}`;

      if (sourceExists(id)) {
        map
          .getStyle()
          .layers.filter((l) => l.source === id)
          .forEach((l) => map.removeLayer(l.id));

        if (map.getSource(id)) {
          map.removeSource(id);
        }
      }

      const layers = map.getStyle() ? map.getStyle().layers : false;
      const firstLayerId = layers.length ? layers[0].id : null;
      if (type === "vector") {
        map.addSource(id, {
          type: type,
          tiles: [
            `${__myapp.env.API_URL}/api/v1/smartmap/tilemap/vector/{x}.{y}.{z}.${vrstvyUrl[type]}.pbf`,
          ],
          maxzoom: 15,
          minzoom: 0,
        });

        const typy = vrstvyUrl[type].split(",");
        typy.forEach((typ) => {
          const source_id = `${id}_${typ}`;
          const vrstvy = vratVrstvyMapyPodlaTypu(typ);
          const celyTyp = vratTypPodlaKodu(typ);
          if (vrstvy) {
            vrstvy.forEach((vrstva, i) => {
              // vrstva moze mat nastavenia pre paint aj pre layout. Je to podla rozneho typu vrstvy
              for (const v in vrstva.paint) {
                if (typeof vrstva.paint[v] === "string") {
                  vrstvy[i].paint[v] = vrstvy[i].paint[v].replace(
                    /\%kod_farby\%/,
                    `#${vratHtmlKodFarbyPodlaTypu(typ)}`
                  );
                }
              }

              for (const v in vrstva.layout) {
                if (typeof vrstva.layout[v] === "string") {
                  vrstvy[i].layout[v] = vrstvy[i].layout[v].replace(
                    /\%kod_farby\%/,
                    `#${vratHtmlKodFarbyPodlaTypu(typ)}`
                  );
                }
              }

              // ak nemam v konfigu vetvu pre layout, tak ju vytvorim
              if (vrstva.layout === undefined) {
                vrstva.layout = {};
              }

              const typ_vrstvy = vrstva.typ_vrstvy;
              // vytvorim layer pre danu vrstvu
              let layerOptions = {
                id: `${source_id}_${i}`,
                type: typ_vrstvy,
                source: id,
                minzoom: vrstva.minzoom || null,
                paint: vrstva.paint || {},
                layout: vrstva.layout || {},
              };
              if (vrstva.filter) {
                layerOptions.filter = vrstva.filter;
              }
              if (celyTyp.koddb) {
                layerOptions["source-layer"] = celyTyp.koddb;
              } else {
                layerOptions["source-layer"] = typ.replace(/^v/, "");
              }
              const l = map.addLayer(layerOptions, firstLayerId);
            });
          }
        });
      } else {
        map.addSource(id, {
          type: type,
          tiles: [
            `${__myapp.env.API_URL}/api/v1/smartmap/tilemap/raster/{x}.{y}.{z}.${vrstvyUrl[type]}.jpg`,
          ],
          tileSize: 256,
          maxzoom: get(get_store(configStore), "layers.maxzoom", 20),
        });
        map.addLayer(
          {
            id: id,
            type: type,
            source: id,
            maxzoom: get(get_store(configStore), "layers.maxzoom", 20),
            minzoom: get(get_store(configStore), "layers.minzoom", 20),
          },
          firstLayerId
        );
      }
    }
  });

  const dlbclick_func = (e) => {
    hooksStore.doAction("dblclick", e);
  };

  // kontroluje sa v tempe, ci je premenna meranieAktivne
  // podla toho povoluje alebo zakazuje dvojklik
  const unsubscribe = tempStore.subscribe((value) => {
    meranieAktivne = get(value, "meranieAktivne", false);
    if (map) {
      if (!meranieAktivne) {
        map.on("dblclick", dlbclick_func);
      } else {
        map.off("dblclick", dlbclick_func);
      }
    }
  });

  // ziskam si zemenpisnu dlzku, sirku a zoom
  const { lat, lng, zoom } = ziskajUlozenuPoziciuMapy();

  onMount(() => {
    map = new maplibregl.Map({
      container: container,
      center: [lng, lat], //17.27412, 48.22231 [lng, lat]
      zoom: zoom,
      minZoom: 9,
      maxZoom: get(get_store(configStore), "map.maxZoom", 20),
      // maxBounds: obecConfig.map.maxBounds,
      style: {
        version: 8,
        sources: {},
        layers: [],
        glyphs: "assets/fonts/{fontstack}/{range}.pbf",
      },
      preserveDrawingBuffer: true,
      hash: true,
      doubleClickZoom: false,
      transformRequest: (url, resourceType) => {
        if (
          url.includes("zbgisws.skgeodesy.sk") === false &&
          url.includes("fonts.openmaptiles.org") === false
        ) {
          return {
            url: url,
            credentials: "include", // Include cookies for cross-origin requests
          };
        }
      },
    });

    map.on("moveend", (x) => {
      ulozAktualneZobrazenieMapy(map);
    });

    map.on("render", function () {
      // map.resize();
    });

    map.on("load", () => {
      map.resize();
      map.doubleClickZoom.disable();
      hooksStore.doAction("aktualizujVrstvyNaMape");
      map.loadImage(`/assets/img/marker-icon.png`, function (error, image) {
        if (error) throw error;
        map.addImage("marker", image, { pixelRatio: 1, sdf: true }); // 38x55px, shadow adds 5px (for scale eq 1)
      });
      hooksStore.doAction("nacitajUlozenyStav");
    });

    map.on("dblclick", dlbclick_func);

    return () => {
      map.remove();
      // link.parentNode.removeChild(link);
    };
  });
</script>

<!-- Map start  -->
<div class="content__map" bind:this={container}>
  {#if map}
    <slot />
    <SideManager />
    <Popup />
    <Controls />
  {/if}
</div>

<!-- Map end  -->
<style>
  .content__map {
    position: relative;
    width: 100%;
    height: 100%;
  }
</style>
